export default "/assets/open-in-new-window-2c8a3b416e217eeaeae024f237e9948eab791085892bcbb88c80ff4233340fa2.svg";